import { margin } from "ds_legacy/materials/metrics";
import { Caption, FONT_SIZE_12 } from "ds_legacy/materials/typography";
import { CSSProperties } from "react";
import { useTranslations } from "translations";

export function AsteriskExplained({
  customMargin,
  style,
}: {
  customMargin?: string;
  style?: CSSProperties;
}) {
  const translations = useTranslations();
  return (
    <Caption
      as="p"
      fontSize={FONT_SIZE_12}
      margin={customMargin ?? margin(1, 0, 0)}
      style={{ alignSelf: "flex-start", ...style }}
      whiteSpace="normal"
    >
      {translations.providersearch.assessment.mandatoryFieldInformation}
    </Caption>
  );
}
